import config from '../config';
import selectedEnvironment from '../env';
const API_URL = `${config[selectedEnvironment].API_URL}`;

const jsonHeaders = (auth) => ({
    "Authorization": 'Bearer ' + auth,
    "Content-Type": "application/json"
});

const readError = async (response, fallback) => {
    const text = await response.text();
    return new Error(text || fallback);
};

/**
 * Asks the server for AI bank-matching suggestions. Nothing is persisted; every suggestion comes back
 * already balanced (or carrying the journal entry that balances it).
 */
const Suggest = async ({ caseId, accountCodeId, startDate, endDate, prompt, externalIds, internalIds }, auth, signal) => {
    const response = await fetch(`${API_URL}/BankMatchAi/Suggest`, {
        method: 'POST',
        headers: jsonHeaders(auth),
        signal,
        body: JSON.stringify({
            caseId,
            accountCodeId,
            startDate,
            endDate,
            prompt: prompt || null,
            externalIds: externalIds?.length ? externalIds : null,
            internalIds: internalIds?.length ? internalIds : null,
        })
    });
    if (!response.ok) throw await readError(response, 'Failed to get AI suggestions');
    return response.json();
};

const RecordDecision = async (decision, auth) => {
    const response = await fetch(`${API_URL}/BankMatchAi/Decisions`, {
        method: 'POST',
        headers: jsonHeaders(auth),
        body: JSON.stringify(decision)
    });
    if (!response.ok) throw await readError(response, 'Failed to record AI decision');
};

const GetMemory = async (caseId, accountCodeId, auth) => {
    const params = new URLSearchParams({ caseId, accountCodeId });
    const response = await fetch(`${API_URL}/BankMatchAi/Memory?${params}`, {
        method: 'GET',
        headers: jsonHeaders(auth)
    });
    if (!response.ok) throw await readError(response, 'Failed to load AI memory');
    return response.json();
};

const BankMatchAiService = {
    Suggest,
    RecordDecision,
    GetMemory,
};

export default BankMatchAiService;
